import React, { useEffect } from 'react';
import withAuth from '../../../hocs/withAuth';
import { Row, Col, Container, Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
	fetchMyBusiness,
	removeNewsFeed,
} from '../../../store/actions/business';
import { FileText, CalendarDays, Trash2 } from 'lucide-react';

import NavbarBusiness from '../../Components/BusinessNavbar';
import BusinessSidebar from '../../Components/BusinessSidebar';
import BlogPostForms from '../../Modals/BlogPostForms';

import './index.css';

const formatDate = (date) => {
	if (!date) return '';
	return new Date(date).toLocaleDateString('en-CA', {
		month: 'short',
		day: 'numeric',
		year: 'numeric',
	});
};

const FeedPostsPage = () => {
	const dispatch = useDispatch();

	const { id } = useSelector((state) => state.currentUser.user);
	const business = useSelector((state) => state.myBusiness);
	const posts = business?.newsFeeds || [];

	useEffect(() => {
		if (id) {
			dispatch(fetchMyBusiness(id));
		}
	}, [dispatch, id]);

	const handleRemove = (postId) => {
		dispatch(removeNewsFeed(postId));
	};

	return (
		<div className='business-page-shell'>
			<NavbarBusiness />

			<Row className='g-0 no-gutters'>
				<Col xs='12' md='3' lg='3'>
					<BusinessSidebar />
				</Col>

				<Col xs='12' md='9' lg='9' className='business-page-shell__main'>
					<Container fluid className='feed-posts-page'>
						<div className='feed-posts-page__header'>
							<div>
								<h1 className='feed-posts-page__title'>Marketing Posts</h1>
								<p className='feed-posts-page__subtitle'>
									Create posts that can be published to selected buildings
									around your business.
								</p>
							</div>

							<div className='feed-posts-page__actions'>
								<BlogPostForms />
							</div>
						</div>

						<div className='feed-posts-page__summary'>
							<div className='feed-posts-page__summary-card'>
								<div className='feed-posts-page__summary-icon'>
									<FileText size={20} />
								</div>
								<div>
									<div className='feed-posts-page__summary-value'>
										{posts.length}
									</div>
									<div className='feed-posts-page__summary-label'>
										Total posts
									</div>
								</div>
							</div>
						</div>

						{posts.length > 0 ? (
							<Row>
								{posts.map((post) => (
									<Col xl='4' lg='6' md='6' sm='12' key={post._id}>
										<div className='feed-post-card'>
											<div className='feed-post-card__image-wrap'>
												<img
													alt={post.title || 'Marketing post'}
													className='feed-post-card__image'
													src={post.image?.[0]}
												/>
											</div>

											<div className='feed-post-card__body'>
												<div className='feed-post-card__top'>
													<h3 className='feed-post-card__title'>
														{post.title || 'Untitled post'}
													</h3>
												</div>

												{post.subject ? (
													<div className='feed-post-card__subject'>
														{post.subject}
													</div>
												) : null}

												<p className='feed-post-card__description'>
													{post.description || 'No description available.'}
												</p>

												<div className='feed-post-card__meta'>
													<CalendarDays size={15} />
													<span>{formatDate(post.createdAt)}</span>
												</div>

												<div className='feed-post-card__footer'>
													<Button
														type='button'
														className='feed-post-card__remove-btn'
														onClick={() => handleRemove(post._id)}>
														<Trash2 size={16} />
														<span>Remove</span>
													</Button>
												</div>
											</div>
										</div>
									</Col>
								))}
							</Row>
						) : (
							<div className='feed-posts-page__empty'>
								<div className='feed-posts-page__empty-icon'>
									<FileText size={28} />
								</div>
								<h3>No marketing posts yet</h3>
								<p>
									Create your first marketing post to promote your business in
									nearby buildings.
								</p>
								<div className='feed-posts-page__empty-action'>
									<BlogPostForms />
								</div>
							</div>
						)}
					</Container>
				</Col>
			</Row>
		</div>
	);
};

export default withAuth(FeedPostsPage);
